const $_default =
{

}

const $_validator =
{

}

export default
{
    props:
    {
        ranges              : { type: Object },
        selected            : { type: Object },
        localeData          : { type: Object },
        alwaysShowCalendars : { type: Boolean }
    }
}